import TableCardv2 from "../../components/TableCardv2";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import AssignmentLateIcon from "@mui/icons-material/AssignmentLate";
import AddchartIcon from "@mui/icons-material/Addchart";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { debounce } from "lodash";
import styles from "./styles.module.css";
import { useContext, useEffect, useState, useCallback, useRef } from "react";
import { buscarProjetos } from "../../services/api-inss.service";
import Loading from "../../components/Loading";
import { formatValue } from "../../utils/formatValue";
import { PreviaInssContext } from "../PreviaINSS/PreviaInssContext";
import ModalAnalisar from "../PreviaINSS/ModalAnalisar";
import ModalVersoes from "./../PreviaINSS/ModalVersoes";
import { usePermissoes, CHAVES_INSS_VIEW } from "../../config/Context/PermissoesContext";

const ProjetosINSS = () => {
  const { pode, carregado, chaves } = usePermissoes();
  const handleOrganizaDataRef = useRef((x) => x);
  const [projetos, setProjetos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openOrCloseModalAnalisar, setOpenOrCloseModalAnalisar] = useState(false);
  const [modalAnalisar, setModalAnalisar] = useState({});
  const [modalVersoes, setModalVersoes] = useState({open: false, idProjeto: null});
  const { buscaDadosPrevia } = useContext(PreviaInssContext);
  const header = { icon: <CurrencyExchangeIcon />, title: "Projetos INSS" };
  const functionDebounce = debounce((value) => handleDebounce(value), 1000);
  const columns = [
    { key: "razaoSocial", label: "Razão Social" },
    { key: "cnpj", label: "CNPJ" },
    { key: "categoria", label: "Categoria" },
    { key: "dtInicial", label: "Data Inicial" },
    { key: "dtFinal", label: "Data Final" },
    { key: "status", label: "Status" },
  ];

  const handleRechargeData = async () => {
    setLoading(true);
    try {
      const response = await buscarProjetos("inss");
      setProjetos(handleOrganizaDataRef.current(response.projetos));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleInititalData = useCallback(async () => {
    setLoading(true);
    try {
      const responseProjetos = await buscarProjetos("inss");
      // const responseCategorias = await buscarCategoriasTributarias();
      // const organizaCategoria = responseCategorias.categories.map(
      //   (categoria) => {
      //     return {
      //       id: categoria.idCategoriaTributaria,
      //       label: categoria.descricao,
      //     };
      //   }
      // );
      // setCategorias(organizaCategoria);
      setProjetos(handleOrganizaDataRef.current(responseProjetos.projetos));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleOrganizaData = (data) => {
    const btnAnalisar = (row) => {
      if (!pode(CHAVES_INSS_VIEW)) return null;
      return {
        icon: <QueryStatsIcon />,
        title: "Analisar",
        onClick: () => handleModalAnalisar(row),
      };
    };
    const btnVizualizar = {
      icon: <VisibilityIcon />,
      title: "Visualizar",
      onClick: () => handleClick(),
    };

    const formatStatus = (status) => {
      switch (status) {
        case "PROJETO-PENDENTE":
          return (
            <span className={styles.status_container}>
              <span className={styles.andamento} /> Andamento
            </span>
          );
        case "PROJETO-ENVIADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.enviada} /> Enviado
            </span>
          );
        case "PROJETO-APROVADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.aprovada} /> Aprovado
            </span>
          );
        case "PROJETO-CANCELADO":
          return (
            <span className={styles.status_container}>
              <span className={styles.cancelada} /> Cancelado
            </span>
          );
        default:
          break;
      }
    };

    return data.map((item) => {
      const formatBtn = (status) => {
        switch (status) {
          case "PROJETO-PENDENTE":
            return [btnAnalisar(item)].filter(Boolean);
          default:
            return pode(CHAVES_INSS_VIEW) ? [btnVizualizar] : [];
        }
      };
      return {
        razaoSocial: item.razaoSocial,
        cnpj: formatValue("cnpj", item.cnpj),
        categoria: item.categoriaTributaria?.descricao || "Sem categoria",
        dtInicial: formatValue("data", item.dtInicial),
        dtFinal: formatValue("data", item.dtFinal),
        status: formatStatus(item.status),
        btn: formatBtn(item.status),
      };
    });
  };

  handleOrganizaDataRef.current = handleOrganizaData;

  useEffect(() => {
    if (!carregado) return;
    handleRechargeData();
  }, [carregado, chaves]);

  const handleDebounce = (value) => {
    console.log(value);
  };

  const handleModalAnalisar = async (data) => {
    // sessionStorage.setItem("cnpjSelecionado", data.cnpj);
    // setModalVersoes({ open: true, idProjeto: data.idProjetoInss });
    // setOpenOrCloseModalAnalisar(true);
    // await buscaDadosPrevia(data.idEmpresa);
    // setModalAnalisar(data);


    setModalVersoes({ open: true, idProjeto: data.idProjeto });
    // await buscaDadosPrevia(data.idEmpresa);
    setModalAnalisar(data);
  };

  const handleClick = () => {
    console.log("teste");
  };

  return (
    <div className={styles.container}>
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <TableCardv2
          columns={columns}
          data={projetos}
          header={header}
          debounce={functionDebounce}
          loading={loading}
        />
      )}
       <ModalAnalisar
        open={openOrCloseModalAnalisar}
        setOpen={(value) => setOpenOrCloseModalAnalisar(value)}
        data={modalAnalisar}
        rechargeData={handleRechargeData}
        isTab
      />
      <ModalVersoes
        open={modalVersoes.open}
        onClose={() => setModalVersoes({open: false, idProjeto: null })}
        id={modalVersoes.idProjeto}
        tipo="INSS"
        data={modalAnalisar}
        rechargeData={handleInititalData}
        projeto={true}
        tabs
      />
    </div>
  );
};

export default ProjetosINSS;
